import { AnyType } from '@thehubz/shared/model';

export function multiFilterData(filter: { _id: string; name: string }[], objectKey: string) {
  let multiFilter: string[] = [];
  if (filter && Array.isArray(filter)) {
    multiFilter = filter.map((k) => k._id);
    return { [`customFields.${objectKey}`]: { $in: multiFilter } };
  }
  return undefined;
}

/**
 * Function to filter out empty objects from the $or array
 */
export function filterEmptyObjects(array: AnyType[]) {
  return array.filter((obj) => Object.keys(obj).length > 0);
}

/**
 * Construct $in filter object
 * @param filters
 * @returns
 */
export function filterObj(filters: AnyType) {
  if (filters && filters.length) {
    return { $in: filters.map((filter: AnyType) => filter._id) };
  }
  return undefined;
}
